"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _draftExtend = require("draft-extend");

var _SmallToggleButton = _interopRequireDefault(require("../components/SmallToggleButton"));

var _UIDropdown = _interopRequireDefault(require("UIComponents/dropdown/UIDropdown"));

var _UIPopover = _interopRequireDefault(require("UIComponents/tooltip/UIPopover"));

var _UIList = _interopRequireDefault(require("UIComponents/list/UIList"));

var _utils = require("../lib/utils");

var _createPluginStack = require("./createPluginStack");

var memoizedImmutablePush = (0, _utils.memoize)(function (a1, a2) {
  return a1.concat([a2]);
});
var createGroupedButton = (0, _utils.memoize)(function () {
  var icon = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'textColor';
  var tooltip = arguments.length > 1 ? arguments[1] : undefined;
  var tooltipPlacement = arguments.length > 2 ? arguments[2] : undefined;
  var inline = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  var className = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
  var onOpenPopover = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : function () {};
  var buttons = arguments.length > 6 ? arguments[6] : undefined;
  var useDropdown = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : false;
  var dropdownText = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : '';
  return (0, _createReactClass.default)({
    displayName: 'GroupedButton',
    propTypes: {
      onChange: _propTypes.default.func,
      editorState: _propTypes.default.object.isRequired
    },
    getInitialState: function getInitialState() {
      return {
        open: false
      };
    },
    componentDidMount: function componentDidMount() {
      var _this = this;

      this.keyDownHandler = function (evt) {
        var target = evt.target;

        if (target.className.includes('public-DraftEditor-content')) {
          // user is typing in their content, close the popover so it's not
          // distracting
          _this.handlePopoverClose();
        }
      };

      document.addEventListener('keydown', this.keyDownHandler);
    },
    componentWillUnmount: function componentWillUnmount() {
      if (this.keyDownHandler) {
        document.removeEventListener('keydown', this.keyDownHandler);
      }
    },
    handlePopoverClose: function handlePopoverClose() {
      this.setState({
        open: false
      });
    },
    togglePopover: function togglePopover() {
      this.setState(function (_ref) {
        var open = _ref.open;

        if (!open && onOpenPopover) {
          onOpenPopover();
        }

        return {
          open: !open
        };
      });
    },
    handleOpenChange: function handleOpenChange(e) {
      this.setState({
        open: e.target.value
      });
    },
    renderButtons: function renderButtons() {
      var _this2 = this;

      return buttons.map(function (Button, index) {
        return _react.default.createElement(Button, Object.assign({
          key: index,
          closePopover: _this2.handlePopoverClose
        }, _this2.props));
      });
    },
    renderButtonList: function renderButtonList() {
      return _react.default.createElement(_UIList.default, {
        className: className,
        childClassName: "p-x-0",
        inline: inline
      }, this.renderButtons());
    },
    render: function render() {
      var open = this.state.open;

      if (!buttons) {
        return null;
      }

      var sharedProps = {
        open: this.state.open,
        closeOnOutsideClick: true,
        onOpenChange: this.handleOpenChange,
        placement: 'top right'
      };

      if (useDropdown) {
        return _react.default.createElement(_UIDropdown.default, Object.assign({}, sharedProps, {
          buttonClassName: "draft-toolbar-dropdown",
          buttonUse: "transparent",
          buttonText: dropdownText,
          className: "draft-toolbar-group",
          closeOnMenuClick: false,
          Content: this.renderButtonList
        }));
      }

      return _react.default.createElement(_UIPopover.default, Object.assign({}, sharedProps, {
        Content: this.renderButtonList
      }), _react.default.createElement(_SmallToggleButton.default, {
        className: "plugin-group-button",
        active: open,
        icon: icon,
        onClick: this.togglePopover,
        tooltip: tooltip,
        tooltipPlacement: tooltipPlacement
      }));
    }
  });
});

var addGroupedButtons = function addGroupedButtons(WrappingComponent, options) {
  // eslint-disable-next-line react/no-multi-comp
  return (0, _createReactClass.default)({
    propTypes: {
      buttons: _propTypes.default.array.isRequired,
      otherButtons: _propTypes.default.array.isRequired
    },
    focus: function focus() {
      if (this.refs.child.focus) {
        this.refs.child.focus();
      }
    },
    blur: function blur() {
      if (this.refs.child.blur) {
        this.refs.child.blur();
      }
    },
    render: function render() {
      var _this$props = this.props,
          buttons = _this$props.buttons,
          otherButtons = _this$props.otherButtons,
          otherProps = (0, _objectWithoutProperties2.default)(_this$props, ["buttons", "otherButtons"]);
      var icon = options.icon,
          tooltip = options.tooltip,
          tooltipPlacement = options.tooltipPlacement,
          inline = options.inline,
          className = options.className,
          onOpenPopover = options.onOpenPopover,
          useDropdown = options.useDropdown,
          dropdownText = options.dropdownText;
      var GroupedButton = createGroupedButton(icon, tooltip, tooltipPlacement, inline, className, onOpenPopover, buttons, useDropdown, dropdownText);
      var allButtons = memoizedImmutablePush(otherButtons, GroupedButton);
      return _react.default.createElement(WrappingComponent, Object.assign({
        ref: "child",
        buttons: allButtons
      }, otherProps));
    }
  });
};

var _default = function _default(plugins) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  // try to turn the passed plugins into a single plugin stack. if that works,
  // we can do so and change the buttons to be a single grouped one. if not, we
  // need to keep plugins separate to preserve plugin order.
  var pluginStack = _createPluginStack.createPluginStack.apply(void 0, (0, _toConsumableArray2.default)(plugins));

  var stackSets = pluginStack({
    __isAccumulator: true
  });
  var canCombineGroupedPlugins = stackSets.length === 1;
  var pluginProps = null;

  if (canCombineGroupedPlugins) {
    var _stackSets = (0, _slicedToArray2.default)(stackSets, 1),
        firstPluginStack = _stackSets[0];

    pluginProps = firstPluginStack({
      __isAccumulator: true
    });
  }

  if (plugins.length === 0) {
    return function (WrappingComponent) {
      return WrappingComponent;
    };
  }

  return function (WrappingComponent) {
    if (WrappingComponent && WrappingComponent.__isAccumulator && canCombineGroupedPlugins) {
      var _pluginProps = pluginProps,
          buttons = _pluginProps.buttons,
          otherPluginProps = (0, _objectWithoutProperties2.default)(_pluginProps, ["buttons"]);
      var icon = options.icon,
          tooltip = options.tooltip,
          tooltipPlacement = options.tooltipPlacement,
          inline = options.inline,
          className = options.className,
          onOpenPopover = options.onOpenPopover,
          useDropdown = options.useDropdown,
          dropdownText = options.dropdownText;
      var GroupedButton = createGroupedButton(icon, tooltip, tooltipPlacement, inline, className, onOpenPopover, buttons, useDropdown, dropdownText);
      var groupedButtonConfig = Object.assign({
        buttons: [GroupedButton]
      }, otherPluginProps);
      return Object.assign({}, (0, _draftExtend.accumulatePluginOptions)(WrappingComponent, groupedButtonConfig), {
        __pluginStack: plugins.length + "(GenericPluginGroupStack)"
      });
    }

    if (WrappingComponent.prototype && WrappingComponent.prototype.isReactComponent) {
      var buttonGrouper = options.addGroupedButtons || addGroupedButtons; // wrapping Editor component, so accumulate rendering options on a single GroupedButton

      var WrappedEditorWithGroupedButtons = _draftExtend.compose.apply(void 0, (0, _toConsumableArray2.default)(plugins))(buttonGrouper(WrappingComponent, options)); // eslint-disable-next-line react/no-multi-comp


      return (0, _createReactClass.default)({
        propTypes: {
          buttons: _propTypes.default.array
        },
        getDefaultProps: function getDefaultProps() {
          return {
            buttons: []
          };
        },
        focus: function focus() {
          if (this.refs.child.focus) {
            this.refs.child.focus();
          }
        },
        blur: function blur() {
          if (this.refs.child.blur) {
            this.refs.child.blur();
          }
        },
        render: function render() {
          var _this$props2 = this.props,
              buttons = _this$props2.buttons,
              otherProps = (0, _objectWithoutProperties2.default)(_this$props2, ["buttons"]);
          return _react.default.createElement(WrappedEditorWithGroupedButtons, Object.assign({}, otherProps, {
            ref: "child",
            otherButtons: buttons
          }));
        }
      });
    } // not an Editor component, so accumulate as usual


    return _draftExtend.compose.apply(void 0, (0, _toConsumableArray2.default)(plugins))(WrappingComponent);
  };
};

exports.default = _default;
module.exports = exports.default;